/*
 * Packages as decided by the owner (Settings briefs, 23-24/10/2026). Only what was decided is written here;
 * team size is not decided and is not shown. Nothing is for sale and no limit is enforced in this release.
 */
export interface PlanItem {
  text: string;
  /** false: part of the plan that does not exist in the app yet */
  ready: boolean;
}
export interface Plan {
  id: "free" | "collector" | "full";
  name: string;
  /** Thai baht; null = free */
  monthly: number | null;
  yearly: number | null;
  /** badge on the card: when it applies */
  badge: string;
  includes: PlanItem[];
}

export const FREE_ACTION_LIMIT = 20;

export const PLANS: Plan[] = [
  { id: "free", name: "Free", monthly: null, yearly: null, badge: "หลังจบ Beta",
    includes: [{ text: `Action รวมทั้งบัญชี ${FREE_ACTION_LIMIT} รายการ`, ready: true }] },
  { id: "collector", name: "Collector", monthly: 39, yearly: 299, badge: "ยังไม่เปิดขาย",
    includes: [{ text: "Action ไม่จำกัด", ready: true }] },
  { id: "full", name: "Full Access", monthly: 89, yearly: 687, badge: "แผนในอนาคต",
    includes: [
      { text: "ทุกอย่างใน Collector", ready: true },
      { text: "Designer", ready: false },
      { text: "Workstation", ready: false },
      { text: "Secret Zone", ready: false }
    ] }
];

/** true while there is no payment and no limit: every account uses the app as it is, without a package */
export const PLANS_ON_SALE = false;
